import { useQuery } from '@apollo/client';
import { GET_TRUSTS_USERS } from '../graphql/queries/getTrustsUsers';

export interface TrustsUser {
  email: string;
  status?: string | null;
  enabled?: boolean;
  createdDate?: string | null;
}

export const useGetTrustsUsers = () => {
  const { loading, error, data, refetch } = useQuery<{ trustsUsers: TrustsUser[] }>(GET_TRUSTS_USERS, {
    fetchPolicy: 'cache-and-network'
  });

  const users = data?.trustsUsers ?? [];

  return { loading, error, users, refetch };
};
